import { Types } from '../../../constants';
import { IsHelper } from '../IsHelper';
export class IsSymbolHelper extends IsHelper {
    constructor() {
        super(...arguments);
        this.type = Types.Symbol;
    }
}

//# sourceMappingURL=IsSymbolHelper.js.map
